export const DEFAULT_BLOCK_VIEW = "workouts-string";

export const shouldShowBlockDashboardSection = (coach) =>
  coach?.showBlockDashboardSection !== false;

export const shouldShowProtocolSlotUi = (coach) =>
  shouldShowBlockDashboardSection(coach) && coach?.hideBlockDashboard !== true;

export const shouldShowOnlyProtocolSlotsToggle = ({
  coach,
  blockHasProtocolSlots,
}) => shouldShowProtocolSlotUi(coach) && blockHasProtocolSlots === true;

export const shouldEnableOnlyProtocolSlotsMode = ({
  coach,
  blockHasProtocolSlots,
}) =>
  shouldShowOnlyProtocolSlotsToggle({ coach, blockHasProtocolSlots }) &&
  coach?.showOnlyProtocolSlots === true;

export const getResolvedCoachDefaultBlockView = (coach) => {
  if (!shouldShowBlockDashboardSection(coach)) {
    return DEFAULT_BLOCK_VIEW;
  }

  return coach?.defaultBlockView ?? DEFAULT_BLOCK_VIEW;
};
